import { ResidentialUnitSelectFilterable } from '@ygtechnologies/bygr-frontend-component-library';
import React, { useState } from 'react';
// import theme from './ProjectModulesUnitsModal.module.scss';
import { BygrModule } from '@/types';
import { useAsyncStateWithIsLoading } from '@/utils/hooks';
import { uniq } from 'lodash-es';
import { getResidentialUnitLinkInfo } from '@/services/projects';
import { setModuleForResidentialUnits } from '@/services/residentialUnit';
import { SlideToggle, Button, ButtonBar, Dialog } from '@ygtechnologies/rubus-ui';

interface ProjectModulesUnitsModalProps {
    isOpen: boolean;
    toggle(): void;
    projectId: number;
}

const ProjectModulesUnitsModal: React.FC<ProjectModulesUnitsModalProps> = ({ isOpen, toggle, projectId }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [selectedUnits, setSelectedUnits] = useState<number[]>([]);
    const [units] = useAsyncStateWithIsLoading(() => getResidentialUnitLinkInfo(projectId), [projectId], null);
    const [module, setModule] = useState<BygrModule>(BygrModule.None);
    const hasModule = (m: BygrModule) => m === (module & m);

    const toggleModule = (m: BygrModule) => {
        if (hasModule(m)) {
            setModule(module & ~m);
        } else {
            setModule(module | m);
        }
    };

    const setModuleForUnits = async () => {
        setIsLoading(true);
        if (module === BygrModule.None) {
            return window.alert('Need to have one module.');
        }
        if (selectedUnits.length === 0) {
            return window.alert('Need to select units.');
        }
        await setModuleForResidentialUnits(selectedUnits, module);
        setIsLoading(false);
        toggle();
    };

    return (
        <Dialog open={isOpen} onOpenChange={(open) => !open && toggle()}>
            <Dialog.Content contentWidth="lg">
                <Dialog.Header>Change buyer modules for residential units</Dialog.Header>
                <SlideToggle
                    onChange={() => toggleModule(BygrModule.ChangeManagement)}
                    checked={hasModule(BygrModule.ChangeManagement)}>
                    Change management
                </SlideToggle>

                <SlideToggle
                    checked={hasModule(BygrModule.Aftermarket)}
                    onChange={() => toggleModule(BygrModule.Aftermarket)}>
                    Aftermarket
                </SlideToggle>

                {units && (
                    <ResidentialUnitSelectFilterable
                        filterData={{
                            floors: uniq(units.map((x) => x.floor)),
                            groups: uniq(
                                units
                                    .filter((x) => x.residentialUnitGroupId)
                                    .map((x) => ({ name: x.residentialUnitGroupName, id: x.residentialUnitGroupId! }))
                            ),
                            layoutTypes: uniq(units.map((x) => x.layoutType)),
                            tags: [],
                        }}
                        onSelectionChange={(v) => setSelectedUnits(v)}
                        residentialUnitsLinkInfo={units.map((x) => ({ ...x, linkedGroups: [], tags: [] }))}
                        tags={[]}
                        value={selectedUnits}
                    />
                )}
                <ButtonBar>
                    <ButtonBar.Right>
                        <Button loading={isLoading} variant="primary" onClick={setModuleForUnits}>
                            Set module
                        </Button>
                    </ButtonBar.Right>
                </ButtonBar>
            </Dialog.Content>
        </Dialog>
    );
};

export default ProjectModulesUnitsModal;
